/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalConstants } from '../../../../../toolbelt/feature/src/lib/constants/global-constants';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { SysqueElectricalState } from '../../../../feature/src/lib/models/sysque-electrical-state';

@Injectable({
  providedIn: 'root',
})

export class SysQueStateService {
  private electricalStateSubject: BehaviorSubject<SysqueElectricalState> = new BehaviorSubject<SysqueElectricalState>(
    this.loadStateFromLocalStorage()
  );
  public electricalState$: Observable<SysqueElectricalState> = this.electricalStateSubject.asObservable();

  private manageSrcSubject: BehaviorSubject<SysqueElectricalState> = new BehaviorSubject<SysqueElectricalState>(
    this.getElectricalState()
  );
  public manageSrc$: Observable<SysqueElectricalState> = this.manageSrcSubject.asObservable();

  private manageDestSubject: BehaviorSubject<SysqueElectricalState> = new BehaviorSubject<SysqueElectricalState>(
    this.getElectricalState()
  );
  public manageDest$: Observable<SysqueElectricalState> = this.manageDestSubject.asObservable();

  constructor(private localStorageService: LocalStorageService) {}

  public setElectricalState(state: SysqueElectricalState): void {
    this.electricalStateSubject.next({ ...state });
    this.updateLocalStorage(state);
  }

  public setManageSrcState(state: SysqueElectricalState): void {
    this.manageSrcSubject.next({ ...state });
  }

  public setManageDestState(state: SysqueElectricalState): void {
    this.manageDestSubject.next({ ...state });
  }

  public updateProperty(propertyName: string, value: any): void {
    const currentState = this.electricalStateSubject.getValue();
    currentState[propertyName] = value;
    this.electricalStateSubject.next(currentState);
  }

  public updateSrcProperty(propertyName: string, value: any): void {
    const currentState = this.manageSrcSubject.getValue();
    currentState[propertyName] = value;
    this.manageSrcSubject.next(currentState);
  }

  public updateDestProperty(propertyName: string, value: any): void {
    const currentState = this.manageDestSubject.getValue();
    currentState[propertyName] = value;
    this.manageDestSubject.next(currentState);
  }

  public getManageSrcState(): SysqueElectricalState {
    return { ...this.manageSrcSubject.getValue() };
  }

  public getManageDestState(): SysqueElectricalState {
    return { ...this.manageDestSubject.getValue() };
  } 

  public getElectricalState(): SysqueElectricalState {
    return { ...this.electricalStateSubject.getValue() };
  }

  public loadStateFromLocalStorage(): SysqueElectricalState {
    const storedState = localStorage.getItem(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY);
    return storedState ? JSON.parse(storedState) : new SysqueElectricalState();
  }

  public updateLocalStorage(value: SysqueElectricalState): void {
    this.localStorageService.updateStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY, value);
  }
}
